/**
 * A filter that also reports its own count.
 *
 * The guest list used to show the RSVP breakdown twice — once as stat panels and
 * again as filter buttons directly underneath, with the same five numbers. Put
 * the count on the filter and one of them can go: the number is still there, and
 * now it is attached to the thing that acts on it.
 */
export function FilterPill({
  label,
  count,
  selected,
  onSelect,
}: {
  label: string;
  count?: number;
  selected: boolean;
  onSelect: () => void;
}) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={onSelect}
      className={`inline-flex min-h-tap items-center gap-1.5 rounded-pill border px-3 text-caption transition-colors ${
        selected
          ? 'border-leaf bg-leaf text-cream'
          : 'border-line bg-paper text-leaf-soft hover:border-leaf-soft hover:text-leaf'
      }`}
    >
      <span>{label}</span>
      {count !== undefined && (
        <span className={`tabular ${selected ? 'text-cream/70' : 'text-leaf-soft/70'}`}>
          {count}
        </span>
      )}
    </button>
  );
}
